<template lang="pug">
    .dev
        v-toolbar( color="grey darken-4" dark )
            v-toolbar-title {{ dynamicTittleToolbar }}
            v-spacer
            v-btn( color="grey darken-3" depressed @click="backPreviousView" ) 
                v-icon.mr-2 arrow_back 
                span Volver
        crud-form(
            no-buttons
            no-elevation
            read-only
            ref="formDialog"
            :fields="fields" 
            :show-labels="false" 
        )
        template( v-if="showGoToDocument" )
            v-btn( @click="submitGoToDocument" ) {{ dynamicButtonText }}
            v-autocomplete(
                label="Folio"
                :items="itemList" 
                item-text="invoice_number"
                item-value="id"
                style="display:inline-block;"
                v-model="sonDocumentId"
            )
</template>

<script>
//-
import FieldsPchInvoiceDetails from './PchTaxDocumentFields'
import { CrudForm } from '@/components/reusable_components'
import {mapActions} from 'vuex'
import PchInvoiceService from '@/services/api/purchaseInvoice/PurchaseInvoiceServices'
import PchTaxDocumentService from '@/services/api/purchaseTaxDocument/fetchTaxDocumentById'
import PurchaseOrdersService from '@/services/api/purchaseOrders/fetchPchInvoiceByNumber'
import moment from "moment";

export default {
    name: 'pch-invoice-details',
    props: {},
    data: function(){
        return {
            formData: {},
            fields: FieldsPchInvoiceDetails,
            showGoToDocument: false,
            itemList: [],
            sonDocumentId: null,
        }
    },
    computed: {
        calculateStateByMoney: function() {
            console.log('formData: ', this.formData)
            var moment = require('moment')
            const today = new Date()
            const dataResult = moment(this.formData.emission_date, 'YYYY-MM-DD').isSameOrAfter(today)
            if (this.formData.pch_provider_debt_to_pay !== null) {
                const total = this.formData.pch_provider_debt_to_pay.total
                const total_pagado = this.formData.pch_provider_debt_to_pay.total_paid
                if (dataResult) {
                    if (total == total_pagado) {
                        return 'Pagado'
                    } else if (total > total_pagado) {
                        return 'Pendiente'
                    }
                } else {
                    return 'Atrasado'
                }
            } else {
                return 'Pago indefinido'
            }
        },
        hasItems() {
            return this.itemList.length>0
        },
        dynamicTittleToolbar: function() {
            switch(this.formData.document_type){
                case 'Factura':
                    return 'Factura'
                    break
                case 'Nota de Débito':
                    return 'Nota de débito'
                    break
            }
        },
        dynamicButtonText: function() {
            switch(this.formData.document_type){
                case 'Factura':
                    return 'Ver Orden de compra'
                    break
                case 'Nota de Débito':
                    return 'Ver factura'
                    break
            }
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        backPreviousView: function(){
            window.history.back()
        },
        submitGoToDocument: function() {
            switch(this.formData.document_type){
                case 'Factura':
                    this.goToPurchaseOrders()
                    break
                case 'Nota de Débito':
                    this.goToPurchaseInvoice()
                    break
            }
        },
        goToPurchaseOrders: function() {
            this.$router.push(`/purchase_orders/${this.sonDocumentId}`)
            console.log('Go To Purchase Orders - Ir a Orden de Compra!')
        },
        goToPurchaseInvoice: function() {
            this.$router.push( `/purchase_tax_documents/${this.sonDocumentId}?type=Factura` )
            console.log('Go To Purchase Invoice Details - Ir a Factura!')
        },
        fillFields: async function() {
            let customerInfo = await PchTaxDocumentService.fetchTaxDocument(this.$route.params.id, this.$route.query.type)
            //- fill
            this.formData = customerInfo
            this.fields[0].value = customerInfo.folio
            this.fields[1].value = customerInfo.pch_provider.business_name
            this.fields[2].value = customerInfo.pch_provider.rut
            this.fields[3].value = customerInfo.pch_provider_branch_offices.address
            this.fields[4].value = moment(customerInfo.emission_date).format('DD-MM-YYYY')
            this.fields[5].value = moment(customerInfo.payment_date).format('DD-MM-YYYY')
            this.fields[6].value = customerInfo.pch_payment_condition.type
            this.fields[7].value = customerInfo.new_subtotal
            this.fields[8].value = customerInfo.iva
            this.fields[9].value = customerInfo.total
            this.fields[10].value = this.calculateStateByMoney
            this.fields[11].value = customerInfo.is_exent
            this.fields[12].value = customerInfo.payable
            this.fields[13].value = customerInfo.was_replaced

            this.fields = [...this.fields]
            console.log('tipo documento: ', customerInfo.document_type)
            switch(customerInfo.document_type){
                case 'Factura':
                    this.getInvoiceItems()
                    break
                case 'Nota de Débito':
                    this.getDebitNoteItems()
                    break
            }
        },
        getInvoiceItems: async function() {
            //- Filter to get OC list associate to invoice
            const allInvoiceNumbers = await PurchaseOrdersService(this.formData.folio)
            this.itemList = allInvoiceNumbers
            if(this.hasItems){
                this.sonDocumentId = allInvoiceNumbers[0].id
                this.showGoToDocument = true
            }
        },
        getDebitNoteItems: async function() {
            // FALTA OBTENER FILTRO PARA OBTENER LA FACTURA ASOCIADA A NOTA DE DÉBITO
            if(this.formData.pch_purchase_invoice_id !== null){
                console.log('hay factura(s) asociadas ')
                this.itemList = this.formData.pch_purchase_invoice
                this.sonDocumentId = this.formData.pch_purchase_invoice[0]
                this.showGoToDocument = true
            } else {
                console.log('No hay Facturas en la Nota de Débito! ')
            }
        },
    },
    watch: {},
    components: {
        CrudForm,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function(){
        this.fillFields()
        this.setTitleTopBar('Detalle de documento por pagar')
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    .btnPchInvoice{
        margin-top: -60px;
        z-index: 20;
    }
    .vButtonPchInvoice{
        margin-right: 120px;;
        border: 2px solid #4CAF50;
        // color="blue darken-1" 
        //             flat 
    }
    .vAutocompletePchInvoice{
        position: absolute;
        margin-top: -4px;
        margin-left: -20px;
        width: 6%
    }
    .divToolbarInvoice{
        width:100%;
        display:flex;
        justify-content:space-between;
        align-items: center;
    }
</style>